import React from 'react'

export default function ConfirmDialog({ title, message, confirmText='Confirm', onCancel, onConfirm }){
  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal" onClick={(e)=> e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">{title}</div>
          <div className="modal-actions">
            <button className="btn secondary" onClick={onCancel}>Cancel</button>
            <button className="btn danger" onClick={onConfirm}>{confirmText}</button>
          </div>
        </div>
        <div style={{padding:16, color:'var(--muted)'}}>{message}</div>
      </div>
    </div>
  )
}
